import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import {
  fetchClientByClientIdRequest,
  selectClientIsLoading,
  selectMaybeClient,
  selectSession,
} from '@client';

export const useClientData = () => {
  const { isLoading: authLoading, isAuthenticated } = useAuth0();
  const { clientId } = useParams();
  const dispatch = useDispatch();
  const client = useSelector(selectMaybeClient);
  const clientIsLoading = useSelector(selectClientIsLoading);
  const { advisor } = useSelector(selectSession);

  const isLoading = authLoading || clientIsLoading;

  const shouldBeLoadingClientData =
    !client || (!clientIsLoading && isAuthenticated && !advisor);

  useEffect(() => {
    if (
      clientId &&
      (!client || client.clientId !== clientId) &&
      !isLoading &&
      isAuthenticated
    ) {
      dispatch(fetchClientByClientIdRequest(clientId));
    }
  }, [clientId, client, dispatch, isLoading, isAuthenticated]);

  return {
    client,
    isLoading,
    shouldBeLoadingClientData,
    authLoading,
    clientIsLoading,
  };
};
